import React, { useEffect, useState, PureComponent } from 'react';
import { useParams } from 'react-router-dom';


import module from '../assets/module.svg';
import rocket from '../assets/rocket.png';
import user from '../assets/user.png';

import qrcode from '../assets/qrcode_small.svg';

import questions from '../assets/questions.png';
import video from '../assets/video.png';
import download from '../assets/download.png';
import profile from '../assets/module_profile.png';
import poll from '../assets/poll_big.png';
import ar from '../assets/AR_big.png';


export default function Preview (data) {
    
    if (!!data['project']['COLORS']){

        const root = document.documentElement;

        //Loader background
        root?.style.setProperty("--background",             data['project']['COLORS'][1]['color']);
        root?.style.setProperty("--footer_menu_background", data['project']['COLORS'][2]['color']);//==
        //Rewards and wallet background
        //Rewards header background
        //Leaderboard background
        //Greeting text color
        root?.style.setProperty("--activity_background",    data['project']['COLORS'][7]['color']);
        root?.style.setProperty("--activity_text_color",    data['project']['COLORS'][8]['color']);

        if (data['project']['COLORS'][9])
            root?.style.setProperty("--buttons_background",     data['project']['COLORS'][9]['color']);//==

        if (data['project']['COLORS'][10])
            root?.style.setProperty("--buttons_color",          data['project']['COLORS'][10]['color']);//==

        if (data['project']['COLORS'][11])
            root?.style.setProperty("--module_names",           data['project']['COLORS'][11]['color']);//==
        //Quiz responses gradient color one
        //Quiz responses gradient color two
        //Quiz responses text color

    }
    
    return (
    
        <div className="preview">
            <div className="title">
                Activities
            </div>
            
            <div className="preview_content">
            
            {!!data['project']["PACKETS"]  && 

                data['project']["PACKETS"].map( (module, index) => 
                
                    <div key={index}>

                        <div className="subtitle">
                            {module.name}
                        </div>
                        <div className="modules">
                        
                        
                                {!!module["activities"]  && 

                                module["activities"].map( (activity, index) => 

                                    activity ?
                
                                        <div className="module" key={index}>
                                            <div className="image">
                                                {
                                                    {
                                                        '/quiz': <img src={activity['icon']} alt="" />,
                                                        '/poll': <img src={poll} alt="" />,
                                                        '/video': <img src={video} alt="" />,
                                                        '/download': <img src={download} alt="" />,
                                                        '/profile': <img src={profile} alt="" />,
                                                        '/ar': <img src={ar} alt="" />,

                                                    }[activity.link]
                                                }
                                            </div>
                                            <div className="text">
                                                <div className="name">{activity.name}</div>
                                                <div className="points">+{activity.points} points</div>
                                            </div>
                                            <div className="button_module"></div>
                                        </div>

                                    : null
                                )
                                }
                            
                            {/*
                                
                            <div className="preview_content preview_question">

                                <div className="bg_white">
                                    <div className="title">Question</div>
                                    <div className="subtitle">?</div>
                                    <div className="question">?</div>
                                    <div className="question">?</div>
                                </div>
                                
                            </div>
                                
                                
                            <div className="module">
                                <div className="image"><img src={module} alt="" /></div>
                                <div className="text">
                                    <div className="name">Quiz</div>
                                    <div className="points">+10 points</div>
                                </div>
                                <div className="button_module checked"></div>
                            </div>
                            <div className="module">
                                <div className="image"><img src={module} alt="" /></div>
                                <div className="text">
                                    <div className="name">Download PDF</div>
                                    <div className="points">+5 points</div>
                                </div>
                                <div className="button_module edit"></div>
                            </div>                                                
                            <div className="module">
                                <div className="button_module blocked"></div>
                                <div className="name">Scan QR to unlock</div>
                                <div className="button_module qr-code"></div>
                            </div>                                   
                            */}
                        </div>
                    </div>
                
                )
            
            }
            
            </div>
            
            <div className="control">
                <div className="button_control home">Home</div>
                <div className="button_control game">Game</div>
                <div className="button_control qrcode">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.34513 0.418747C1.25813 0.457387 1.12084 0.589934 1.03385 0.719208C0.990549 0.783531 0.986475 1.05125 0.986475 3.83142C0.986475 7.1829 0.974539 6.96467 1.16577 7.10844C1.38727 7.27496 1.31801 7.27148 4.47738 7.27464C7.62131 7.27778 7.48471 7.28432 7.63445 7.12288C7.6692 7.08543 7.7273 6.9909 7.76357 6.91279L7.82953 6.77076L7.83774 3.95181C7.84339 2.0059 7.83619 1.07497 7.81453 0.94592C7.77401 0.704856 7.65026 0.487114 7.51851 0.425068C7.42827 0.382585 7.14445 0.378399 4.42519 0.379395C1.98315 0.380307 1.41534 0.387568 1.34513 0.418747ZM9.30717 0.410205C9.14056 0.475923 9.01463 0.647338 8.96212 0.879831C8.91865 1.0724 8.92324 6.53166 8.96709 6.73688C9.02398 7.00334 9.14196 7.17157 9.32152 7.24218C9.44366 7.29022 15.2466 7.29221 15.393 7.24429C15.4485 7.2261 15.5409 7.16337 15.5983 7.10488C15.8044 6.89494 15.7916 7.11317 15.7916 3.82367C15.7916 1.20919 15.7863 0.848054 15.747 0.754658C15.6908 0.621171 15.5782 0.502518 15.4412 0.432614C15.3384 0.380136 15.2328 0.378342 12.3569 0.380079C10.4553 0.381246 9.35297 0.392123 9.30717 0.410205ZM6.52479 3.82367V5.97348L4.38686 5.98077L2.24893 5.98809V3.84284C2.24893 2.66295 2.25762 1.68896 2.26824 1.67842C2.27885 1.66789 3.24093 1.66256 4.40617 1.66658L6.52479 1.67387V3.82367ZM14.5004 3.82367V5.98772H12.3629H10.2253V3.82367V1.65963H12.3629H14.5004V3.82367ZM4.22638 2.96913C3.96319 3.01455 3.75629 3.17064 3.62216 3.42503C3.56497 3.53346 3.55459 3.59477 3.55464 3.82367C3.55467 4.06146 3.56391 4.11158 3.63099 4.23789C3.72163 4.40862 3.85582 4.54621 4.01349 4.63009C4.18799 4.72295 4.59226 4.71873 4.78292 4.62206C4.95269 4.53602 5.13185 4.34763 5.21253 4.17038C5.30638 3.96414 5.29898 3.65804 5.19506 3.44724C5.02101 3.09422 4.62741 2.89994 4.22638 2.96913ZM12.1862 2.9691C12.0025 3.00752 11.8503 3.09672 11.7224 3.24103C11.4354 3.56459 11.4354 4.11124 11.7224 4.43479C11.8893 4.62303 12.0272 4.68508 12.3133 4.70065C12.536 4.71278 12.5622 4.70791 12.7393 4.62138C12.9478 4.51953 13.0719 4.37764 13.1579 4.14267C13.2598 3.86425 13.2036 3.47703 13.028 3.24864C12.856 3.02488 12.4941 2.90469 12.1862 2.9691ZM1.42871 8.42426C1.25908 8.467 1.16821 8.53346 1.07074 8.68594L0.986475 8.81784V11.8287C0.986475 13.8826 0.996144 14.865 1.01692 14.9197C1.05766 15.0269 1.20594 15.1774 1.33681 15.2444C1.43961 15.297 1.54479 15.2988 4.40795 15.2988H7.37264L7.50043 15.2347C7.64094 15.1643 7.73878 15.0394 7.79373 14.8603C7.82133 14.7703 7.82953 14.0816 7.82953 11.8534C7.82953 9.1089 7.82684 8.95562 7.77614 8.8112C7.7094 8.62102 7.58585 8.47891 7.44793 8.43358C7.30576 8.38688 1.61211 8.37808 1.42871 8.42426ZM9.3915 8.4469C9.17645 8.50445 9.06972 8.58124 8.99357 8.73324L8.92382 8.87242L8.92858 11.7807C8.93372 14.9366 8.9285 14.831 9.0919 15.076C9.21418 15.2594 9.33589 15.2974 9.80211 15.2982L10.1966 15.2988L10.1968 13.5548C10.1969 12.5955 10.2053 11.724 10.2154 11.618L10.2337 11.4253L10.8823 11.4329L11.5308 11.4405L11.5387 11.9175L11.5465 12.3944H13.6404C14.792 12.3944 15.7437 12.3912 15.7553 12.3873C15.7669 12.3834 15.7804 11.5832 15.7853 10.6091C15.794 8.86659 15.7932 8.83609 15.7349 8.72267C15.6652 8.587 15.5126 8.47931 15.3325 8.43862C15.2615 8.42256 15.0535 8.40912 14.8703 8.40872L14.5373 8.40803L14.5189 8.58307C14.5087 8.67931 14.5004 9.26873 14.5004 9.89288V11.0277H13.8405H13.1806V9.71785V8.40803L11.3515 8.40994C9.99957 8.41137 9.48822 8.42102 9.3915 8.4469ZM6.52479 11.8534V14.0032L4.38686 14.0105L2.24893 14.0178V11.8726C2.24893 10.6927 2.25762 9.71871 2.26824 9.70817C2.27885 9.69763 3.24093 9.69231 4.40617 9.69633L6.52479 9.70362V11.8534ZM4.18228 10.9961C3.78803 11.0969 3.5475 11.3876 3.51783 11.7993C3.49832 12.0698 3.56569 12.2527 3.75337 12.439C3.95883 12.6429 4.1632 12.7174 4.47256 12.7011C4.96581 12.6751 5.27608 12.3474 5.27516 11.8534C5.2745 11.5023 5.09851 11.2198 4.78576 11.068C4.61944 10.9872 4.34482 10.9545 4.18228 10.9961ZM11.6958 13.7552L11.5452 13.7642V14.5315V15.2988H12.2629H12.9807L12.973 14.5241L12.9654 13.7494L12.4059 13.7478C12.0982 13.7469 11.7787 13.7502 11.6958 13.7552ZM14.382 13.7538C14.3126 13.769 14.3003 13.9014 14.2999 14.6368L14.2996 15.2988H14.8248H15.35L15.4803 15.2168C15.6119 15.1339 15.694 15.0376 15.7571 14.8917C15.7799 14.8392 15.7916 14.6306 15.7916 14.2783V13.7446L15.1101 13.7441C14.7354 13.7439 14.4077 13.7482 14.382 13.7538Z" fill="white"/>
                    </svg>
                </div>
                <div className="button_control rating">Rating</div>
                <div className="button_control profile">Profile</div>
            </div>
        </div>
    )

}
